import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import DotsIcon from '@material-ui/icons/MoreHoriz';

const OmaveroStatusIcon = ({data}) => {
  let color = '#000', background, Icon;

  if (!data.ilmoitusvaihe) {
    background = '#eee';
    Icon = 'div';
  } else if (data.ilmoitusvaihe === 'VALMIS') {
    Icon = CheckIcon;
    background = '#81c784';
  } else {
    Icon = DotsIcon;
    background = '#444';
    color = '#fff';
  }

  return (
    <div className="list-icon" style={{background, color}}>
      <Icon />
    </div>
  );
};

export default OmaveroStatusIcon;
